
import React from 'react';
import { Button } from '@/components/ui/button';
import { DollarSign } from 'lucide-react';
import { format } from 'date-fns';
import ReferrerPaymentReport from '@/components/admin/ReferrerPaymentReport';

interface BiweeklyPaymentSectionProps {
  biweeklyReport: {
    startDate: Date;
    endDate: Date;
    payments: any[];
  };
  onMarkAllAsPaid: () => void;
  onMarkAsPaid: (id: string, amount: number, paidBy: string) => void;
}

const BiweeklyPaymentSection: React.FC<BiweeklyPaymentSectionProps> = ({
  biweeklyReport,
  onMarkAllAsPaid,
  onMarkAsPaid,
}) => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
        <div>
          <h3 className="text-lg font-medium">
            Payment Report: {format(biweeklyReport.startDate, "MMM d")} - {format(biweeklyReport.endDate, "MMM d, yyyy")}
          </h3>
          <p className="text-gray-500">
            {biweeklyReport.payments.length} payments pending for this period
          </p>
        </div>
        <Button 
          onClick={onMarkAllAsPaid}
          className="mt-2 md:mt-0 bg-green-600 hover:bg-green-700"
        >
          <DollarSign className="mr-2 h-4 w-4" />
          Mark All as Paid
        </Button>
      </div>
      
      <ReferrerPaymentReport 
        payments={biweeklyReport.payments}
        onMarkAsPaid={onMarkAsPaid}
      />
    </div>
  );
};

export default BiweeklyPaymentSection;
